import { OnchainSDK } from "@gearbox-protocol/sdk/onchain";
import { BotsPlugin } from "@gearbox-protocol/sdk/plugins/bots";
import type { FC, PropsWithChildren } from "react";
import { createContext, useContext } from "react";
import { useAsync } from "react-use";
import type { AsyncState } from "react-use/lib/useAsyncFn";

import logger from "../../logger";
import { useUnpausedForkStatus } from "./context";

const SDKContext = createContext<AsyncState<OnchainSDK>>({ loading: true });

export const SDKProvider: FC<PropsWithChildren> = ({ children }) => {
  const {
    marketConfigurators,
    rwaFactories,
    rpcUrl,
    addressProvider,
    network,
  } = useUnpausedForkStatus();

  const state = useAsync(async () => {
    if (!marketConfigurators?.length) {
      throw new Error("No market configurators found");
    }

    const sdk = new OnchainSDK(
      network,
      { rpcURLs: [rpcUrl], timeout: 480_000 },
      {
        logger,
        plugins: {
          bots: new BotsPlugin(),
        },
      },
    );
    await sdk.attach({
      addressProvider,
      marketConfigurators,
      rwaFactories,
    });

    logger.info("attached sdk");

    return sdk;
  }, [addressProvider, marketConfigurators, rpcUrl, network]);

  return <SDKContext.Provider value={state}>{children}</SDKContext.Provider>;
};

export const useSDK = (): AsyncState<OnchainSDK> => useContext(SDKContext);
